export const InquiryStatus = {
  WAITING: 'WAITING',
  WAITING_VISIT_UNANSWERED: 'WAITING_VISIT_UNANSWERED',
  WAITING_VISITS_ONGOING: 'WAITING_VISITS_ONGOING',
  WAITING_QUOTES_ONGOING: 'WAITING_QUOTES_ONGOING',
  WAITING_QUOTE_ANSWERED: 'WAITING_QUOTE_ANSWERED',
  CANCELLED: 'CANCELLED',
  FINISHED: 'FINISHED',
  ACCEPTED: 'ACCEPTED',
  ACCEPTED_VISIT: 'ACCEPTED_VISIT',
  ACCEPTED_QUOTE: 'ACCEPTED_QUOTE'
}



// WEBPACK FOOTER //
// ./src/constants/InquiryStatus.js